<div class="question">
  <p [innerHTML]="question.title"></p>
  <div [innerHTML]="question.info"></div>
</div>